import { DESKTOP_NOTIFICATION_CODES, SOCKET_API_URL, SOCKET_ENABLED } from "@config";
import { AuthContext } from "@context/AuthContext";
import { useContext, useEffect } from "react";
import io from "socket.io-client";
import EventService from "../services/event.service";

export default function useSocket() {
  /** */

  const { token, isLogedIn } = useContext(AuthContext);

  let socket = undefined;

  useEffect(() => {
    if (!isLogedIn) return console.log("Not Logged In");
    if (!SOCKET_ENABLED) return console.log("Socket Connection Disabled");
    const socket = io(SOCKET_API_URL, { auth: { token } });
    DESKTOP_NOTIFICATION_CODES.forEach((code) => socket.on(code, (payload) => EventService.emit(code, payload)));
    return () => {
      DESKTOP_NOTIFICATION_CODES.forEach((code) => socket.off(code)); // Remove Listeners
      socket.close(); // Close Socket
    };
  }, [isLogedIn]);

  return { socket };
}
